import type { QueryClient } from "@tanstack/react-query";
import { api, mockMode } from "../lib/api";
import { fetchAllPages } from "../lib/fetchAllPages";

const WARMED_KEY = "meta.gestao-veicular.offline-warmed-at";
const REFRESH_AFTER_MS = 6 * 60 * 60_000;
const COLLECTIONS = ["clients", "projects", "companies", "drivers", "vehicles", "accessProfiles"] as const;
const INSPECTION_OPTIONS = ["companies", "projects", "vehicles", "drivers"] as const;

export function lastOfflineRefresh(): number | null {
  try { const value = Number(localStorage.getItem(WARMED_KEY)); return value > 0 ? value : null; } catch { return null; }
}

/**
 * Baixa os cadastros que a vistoria offline precisa. A leitura passa pelo Firestore, que guarda os documentos
 * no cache persistente do aparelho; depois disso, as telas de cadastro e a Nova vistoria abrem sem internet.
 */
export async function warmOfflineCache(queryClient: QueryClient, force = false): Promise<boolean> {
  if (mockMode || typeof navigator === "undefined" || !navigator.onLine) return false;
  const last = lastOfflineRefresh();
  if (!force && last && Date.now() - last < REFRESH_AFTER_MS) return false;
  const results = await Promise.allSettled([
    ...COLLECTIONS.map((name) => api(`/${name}?pageSize=1`)),
    queryClient.prefetchQuery({ queryKey: ["settings"], queryFn: () => api("/settings") }),
    ...INSPECTION_OPTIONS.map((name) => queryClient.prefetchQuery({ queryKey: [name, "inspection-options", false], queryFn: () => fetchAllPages(name, "&active=true") }))
  ]);
  const ok = results.every((result) => result.status === "fulfilled");
  if (ok) { try { localStorage.setItem(WARMED_KEY, String(Date.now())); } catch { /* sem localStorage */ } }
  return ok;
}
